import styled from "styled-components";

export const StyledDescriptionModal = styled.div`
  padding: 20px;
  background-image: linear-gradient(${(p) => p.theme.bg}, ${(p) => p.theme.bg});
  background-color: ${(p) => p.theme.paperBg};
  box-shadow: 0 5px 10px -5px ${(p) => p.theme.shadow};
  border-radius: 8px;
  position: relative;
`;

export const StyledTaskDetailsModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StyledDetailsHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: start;
  padding-right: 95px;
  flex-wrap: wrap;
`;

export const StyledDetailsHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 175px;
`;

export const StyledTaskDetailsIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  z-index: 2;
  border: 5px solid ${(p) => p.theme.primaryDark};
  border-radius: 50%;
`;

export const StyledCloseIcon = styled.div`
  cursor: pointer;
`;

export const StyledDetailsHeaderFloatWrapper = styled.div`
  display: flex;
  gap: 5px;
  position: absolute;
  right: 15px;
  top: 15px;
`;

export const StyledTaskDetailsBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;
`;

export const StyledTaskDetailsBodyLeft = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 4px;
  flex: 1;
`;

export const StyledTaskDetailsBodyRight = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 4px;
  flex: 1;
`;

export const StyledTaskDetailsInfo = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const StyledStreakWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 7.5px 0;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: ${(p) => p.theme.primaryDark};
  color: ${(p) => p.theme.textPrimary};
`;
